<!-- Единый заголовок карточки или секции с адаптивной областью действий. -->
<template>
  <div
    class="base-action-header"
    :class="{
      'base-action-header--wide-spacing': spacing === 'wide',
      'base-action-header--no-spacing': spacing === 'none',
      'base-action-header--stack-wide': stackAt === 'wide',
    }"
  >
    <component :is="titleTag" class="base-action-header__title">
      <slot name="title">{{ title }}</slot>
    </component>

    <div v-if="$slots.default" class="base-action-header__actions">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseActionHeader",

  props: {
    title: {
      type: String,
      default: "",
    },
    titleTag: {
      type: String,
      default: "h3",
    },
    spacing: {
      type: String,
      default: "default",
      validator: (value) => ["default", "wide", "none"].includes(value),
    },
    stackAt: {
      type: String,
      default: "mobile",
      validator: (value) => ["mobile", "wide"].includes(value),
    },
  },
};
</script>

<style scoped>
.base-action-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  width: 100%;
  min-width: 0;
  margin-bottom: var(--base-in-indent);
}

.base-action-header--wide-spacing {
  margin-bottom: var(--base-out-indent);
}

.base-action-header--no-spacing {
  margin-bottom: 0;
}

.base-action-header__title {
  min-width: 0;
  margin: 0;
  overflow-wrap: anywhere;
}

.base-action-header__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 15px;
  min-width: 0;
}

@media (max-width: 1100px) {
  .base-action-header--stack-wide {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .base-action-header--stack-wide .base-action-header__actions {
    display: grid;
    grid-template-columns: repeat(
      auto-fit,
      minmax(min(140px, 100%), 1fr)
    );
    gap: 8px;
    width: 100%;
  }

  .base-action-header--stack-wide
    .base-action-header__actions
    > :last-child:nth-child(odd) {
    grid-column: 1 / -1;
  }
}

@media (max-width: 768px) {
  .base-action-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .base-action-header__actions {
    display: grid;
    grid-template-columns: repeat(
      auto-fit,
      minmax(min(140px, 100%), 1fr)
    );
    gap: 8px;
    width: 100%;
  }

  .base-action-header__actions :deep(.base-button) {
    width: 100%;
    min-width: 0;
  }

  .base-action-header__actions > :last-child:nth-child(odd) {
    grid-column: 1 / -1;
  }
}
</style>
